import { render, staticRenderFns } from "./EmployeeGroup.vue?vue&type=template&id=28adb4c6&scoped=true&"
import script from "./EmployeeGroup.vue?vue&type=script&lang=js&"
export * from "./EmployeeGroup.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeGroup.vue?vue&type=style&index=0&id=28adb4c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28adb4c6",
  null
  
)

export default component.exports